import { ApolloClient } from '@apollo/client'

export type ApolloClientType = ApolloClient<object>

export type LoginErrorResponseType = {
    isUserLockedOut: boolean
    loginRemainingAttempts: number | null
    remainingMinsToUnlock: number | null
    message: string | null
}

export enum LoginErrorEnum {
    INCORRECT_EMAIL,
    LOCKOUT_WARNING,
    FINAL_LOCKOUT_WARNING,
    LOCKED_OUT,
}

export type LoginErrorType = {
    type: LoginErrorEnum
    err: LoginErrorResponseType
}
